var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/connection/Practice/PracticeCard/index.tsx";
import React, { useState } from 'react';
import { Divider, HStack, Stack, Text, VStack } from '@adc/parallax-component-library';
import { IconInfo, IconLinkArrow12x24 } from '@adc/parallax-icons';
import { IconButton, InfoModal, Link } from 'Components/utility';
import { ThemedImage } from 'Components/utility/ThemedImage';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
const PracticeCard = ({
  practiceConnections = [],
  practiceInvitations = []
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return /*#__PURE__*/React.createElement(Stack, {
    padding: "$4",
    backgroundColor: "$surface.container",
    border: "$1.5",
    shadow: "$1",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(HStack, {
    justifyContent: "space-between",
    marginBottom: "$2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(ThemedImage, {
    resourceKey: "Global.microcopy.common.libreViewLogoLight",
    testID: "LibreCard.logo",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(IconButton, {
    testID: "LibreCard.icon-info-btn",
    onPress: () => setIsOpen(true),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(IconInfo, {
    color: "$interactive.tertiary.enabled.onColor",
    testID: "LibreCard.icon-info",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 11
    }
  }))), /*#__PURE__*/React.createElement(VStack, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 7
    }
  }, practiceConnections.length > 0 || practiceInvitations.length > 0 ? /*#__PURE__*/React.createElement(VStack, {
    marginTop: "$4",
    style: {
      cursor: 'pointer'
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 11
    }
  }, practiceInvitations.map(practiceInvitation => {
    return /*#__PURE__*/React.createElement(VStack, {
      key: practiceInvitation.invitationId,
      marginBottom: "$4",
      onPress: () => mediator.publish('router:navigate', {
        url: '/lv-practice-invitation',
        data: {
          practiceInvitation
        }
      }),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 36,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(HStack, {
      justifyContent: "space-between",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 46,
        columnNumber: 19
      }
    }, /*#__PURE__*/React.createElement(Text, {
      testID: "PracticeInvitation.pending-label",
      fontWeight: "$bodyBase.medium",
      fontSize: "$bodyBase.medium",
      color: "$text.100",
      width: "90%",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 47,
        columnNumber: 21
      }
    }, i18n.t('Connections.content.addPractice.secondaryText')), /*#__PURE__*/React.createElement(IconLinkArrow12x24, {
      testID: "PracticeInvitation.arrow-icon",
      color: "$interactive.tertiary.enabled.onColor",
      style: {
        width: 12
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 56,
        columnNumber: 21
      }
    })), /*#__PURE__*/React.createElement(Text, {
      color: "$text.60",
      fontSize: "$bodySmall.default",
      fontWeight: "$bodySmall.default",
      testID: "PracticeInvitation.name",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 62,
        columnNumber: 19
      }
    }, practiceInvitation.name), /*#__PURE__*/React.createElement(Divider, {
      marginTop: "$4",
      borderColor: "$neutral.40",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 70,
        columnNumber: 19
      }
    }));
  }), practiceConnections.map(practiceConnection => {
    return /*#__PURE__*/React.createElement(VStack, {
      key: practiceConnection.practiceId,
      marginBottom: "$4",
      onPress: () => mediator.publish('router:navigate', {
        url: '/lv-practice-connection',
        data: {
          practiceConnection
        }
      }),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 76,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(HStack, {
      justifyContent: "space-between",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 86,
        columnNumber: 19
      }
    }, /*#__PURE__*/React.createElement(Text, {
      testID: "PracticeConnection.name",
      fontWeight: "$bodyBase.medium",
      fontSize: "$bodyBase.medium",
      color: "$text.100",
      width: "90%",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 87,
        columnNumber: 21
      }
    }, practiceConnection.name), /*#__PURE__*/React.createElement(IconLinkArrow12x24, {
      testID: "PracticeConnection.arrow-icon",
      color: "$interactive.tertiary.enabled.onColor",
      style: {
        width: 12
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 96,
        columnNumber: 21
      }
    })), /*#__PURE__*/React.createElement(Divider, {
      marginTop: "$4",
      borderColor: "$neutral.40",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 102,
        columnNumber: 19
      }
    }));
  })) : /*#__PURE__*/React.createElement(Stack, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 108,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Text, {
    marginBottom: "$4",
    testID: "LibreView.message",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 109,
      columnNumber: 13
    }
  }, i18n.t('Connections.content.addPractice.primaryText')), /*#__PURE__*/React.createElement(Divider, {
    marginBottom: "$4",
    borderColor: "$neutral.40",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 112,
      columnNumber: 13
    }
  })), /*#__PURE__*/React.createElement(Link, {
    testID: "LibreView.addPractice-btn",
    onPress: () => {
      mediator.publish('router:navigate', {
        url: '/lv-add-practice'
      });
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 115,
      columnNumber: 9
    }
  }, i18n.t('Connections.content.addPractice.links.addPracticeBtn.label'))), /*#__PURE__*/React.createElement(InfoModal, {
    isOpen: isOpen,
    title: i18n.t('Connections.modals.libreViewBottomSheet.title'),
    content: i18n.t('Connections.modals.libreViewBottomSheet.body'),
    additionalContent: i18n.t('Connections.modals.libreViewBottomSheet.internetConnectionNote'),
    app: "libreView",
    handleClose: () => setIsOpen(false),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 126,
      columnNumber: 7
    }
  }));
};
export default PracticeCard;